import { ConstellationOneListing, PropertyData, mlsInfoByOUID, schFilledAddress } from '@aloft/toolkit-shared';

import { useAutofillProperty } from '../../../hooks/useAutofillProperty.ts';

export const c1ListingToPropertyData =
  (
    autofillProperty: ReturnType<typeof useAutofillProperty>,
    effectiveYear: number,
    orderID: string,
  ) =>
  (listingData: ConstellationOneListing): Promise<PropertyData> => {
    const address = schFilledAddress.safeParse({
      AddressLineText: listingData.UnparsedAddress ?? undefined,
      CityName: listingData.City ?? undefined,
      PostalCode: listingData.PostalCode ?? undefined,
      StateCode: listingData.StateOrProvince ?? undefined,
      CountyName: listingData.CountyOrParish ?? undefined,
    });
    const mlsInfo = mlsInfoByOUID(listingData.MLSOUID);

    const mlsListingInfo =
      mlsInfo?.mlsid && listingData.ListingId
        ? {
            mlsListingID: listingData.ListingId,
            mls: mlsInfo?.mlsid,
          }
        : undefined;

    if (address.success === false)
      throw new Error(
        `Listing must have valid address details to convert to PropertyData: ${JSON.stringify(
          listingData,
        )}`,
      );

    return autofillProperty({
      address: address.data,
      effectiveYear,
      orderID,
      mlsListingInfo,
    });
  };
